import(/* webpackMode: "eager" */ "C:\\dev\\cfs-website\\next\\node_modules\\next\\dist\\client\\script.js");
